import { Eye, X } from 'lucide-react';

import { exitSiteContentPreview, isSiteContentPreview, useSiteContentVersion } from './runtime';

/** The strip a preview tab shows so nobody mistakes the draft for the live site. */
export function SiteContentPreviewBar() {
  useSiteContentVersion();
  if (!isSiteContentPreview()) return null;
  return (
    <div className="sticky top-0 z-[60] flex items-center justify-center gap-3 bg-amber-500 px-4 py-2 text-sm font-medium text-amber-950">
      <Eye className="size-4" aria-hidden />
      <span>Preview - unpublished edits from the site content editor are shown.</span>
      <button
        type="button"
        onClick={exitSiteContentPreview}
        className="inline-flex items-center gap-1 rounded-md bg-amber-950/10 px-2 py-0.5 hover:bg-amber-950/20"
      >
        <X className="size-3.5" aria-hidden />
        Exit preview
      </button>
    </div>
  );
}
